(function () {
	const DESKTOP_ACCORDION_BREAKPOINT = 1150;
	const ACCORDION_TOP_OFFSET = 24;
	const ACCORDION_BOTTOM_OFFSET = 16;
	const MIN_CONSTRAINED_DESCRIPTION_HEIGHT = 140;

	const getOffsetWithinContainer = (element, container) => {
		let top = 0;
		let currentElement = element;

		while (currentElement && currentElement !== container) {
			top += currentElement.offsetTop;
			currentElement = currentElement.offsetParent;
		}

		return top;
	};

	const clearAccordionDescriptionStyles = (descriptionElement) => {
		descriptionElement.style.maxHeight = "";
		descriptionElement.style.overflowY = "";
		descriptionElement.classList.remove("about__accordion-description--constrained");
	};

	const scrollAccordionIntoView = (toggle) => {
		const container = toggle.closest(".product__info-container");
		const item = toggle.closest(".about__accordion-item");

		const itemTop = getOffsetWithinContainer(item, container);

		if (!container || !item) return;

		const nextScrollTop = Math.max(0, itemTop - ACCORDION_TOP_OFFSET);

		if (nextScrollTop !== container.scrollTop) {
			container.scrollTo({
				top: nextScrollTop,
				behavior: "auto",
			});
		}
	};

	const constrainAccordionDescription = (toggleElement) => {
		const container = toggleElement.closest(".product__info-container");
		const item = toggleElement.closest(".about__accordion-item");
		const description = item?.querySelector(".about__accordion-description");

		if (!container || !item || !description) return;

		if (window.innerWidth < DESKTOP_ACCORDION_BREAKPOINT) {
			clearAccordionDescriptionStyles(description);
			return;
		}

		scrollAccordionIntoView(toggleElement);

		const allItems = Array.from(container.querySelectorAll(".about__accordion-item"));
		const currentIndex = allItems.indexOf(item);
		const itemsBelow = allItems.slice(currentIndex + 1);
		const reservedHeight = itemsBelow.reduce((total, accordionItem) => {
			const accordionToggle = accordionItem.querySelector(".about__accordion-toggle");
			return total + (accordionToggle?.offsetHeight || 0);
		}, 0);
		const availableHeight =
			container.clientHeight - ACCORDION_TOP_OFFSET - toggleElement.offsetHeight - reservedHeight - ACCORDION_BOTTOM_OFFSET;
		const nextMaxHeight = Math.max(MIN_CONSTRAINED_DESCRIPTION_HEIGHT, Math.floor(availableHeight));

		description.style.maxHeight = `${nextMaxHeight}px`;
		description.style.overflowY = "auto";
		description.classList.add("about__accordion-description--constrained");
	};

	const setAccordionState = (toggleElement, shouldOpen, animate = true) => {
		const toggle = $(toggleElement);
		const description = toggle.siblings(".about__accordion-description");

		toggle.toggleClass("active", shouldOpen);
		description.stop(true, true);

		if (shouldOpen) {
			if (animate) {
				description.slideDown(300, () => {
					constrainAccordionDescription(toggleElement);
					window.setTimeout(() => {
						constrainAccordionDescription(toggleElement);
					}, 150);
				});
			} else {
				description.show();
				constrainAccordionDescription(toggleElement);
			}
		} else if (animate) {
			clearAccordionDescriptionStyles(description[0]);
			description.slideUp(300);
		} else {
			clearAccordionDescriptionStyles(description[0]);
			description.hide();
		}
	};

	const normalizeAccordionState = () => {
		document.querySelectorAll(".product__info-container").forEach((container) => {
			const toggles = Array.from(container.querySelectorAll(".about__accordion-toggle"));
			let hasOpenedItem = false;

			toggles.forEach((toggleElement) => {
				const shouldStayOpen = toggleElement.classList.contains("active") && !hasOpenedItem;
				setAccordionState(toggleElement, shouldStayOpen, false);

				if (shouldStayOpen) {
					hasOpenedItem = true;
				}
			});
		});
	};

	const initProductAccordion = () => {
		normalizeAccordionState();

		$(".about__accordion-toggle").off("click.productAccordion").on("click.productAccordion", function () {
			const currentToggle = this;
			const container = currentToggle.closest(".product__info-container");
			const otherToggles = Array.from(
				container?.querySelectorAll(".about__accordion-toggle.active") || []
			).filter((toggleElement) => toggleElement !== currentToggle);

			if (!currentToggle.classList.contains("active")) {
				otherToggles.forEach((toggleElement) => setAccordionState(toggleElement, false));
				setAccordionState(currentToggle, true);
			} else {
				setAccordionState(currentToggle, false);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	window.addEventListener("resize", () => {
		document.querySelectorAll(".about__accordion-toggle.active").forEach((toggleElement) => {
			constrainAccordionDescription(toggleElement);
		});
	});

	initProductAccordion();
})();
